var exports = {
  "kL": "x4c3adb35--d6f66d--container",
  "Hw": "x4c3adb35--d6f66d--mobile",
  "_8": "x4c3adb35--d6f66d--img",
  "DD": "x4c3adb35--d6f66d--title",
  "Qq": "x4c3adb35--d6f66d--text",
};

module.exports = exports;
